import { IPaginatedLandingContent } from './models/paginated-landing-content'
import { Filter } from './components/paginated-landing-content-app';

export default function matchesAnyTopicHelper(item: IPaginatedLandingContent, filter: Filter[]) {
    let topicResults = item.topics;
    let matchesTopic;

    if (!topicResults || topicResults.length == 0) {
        return false
    }
    // if any filters match any topics on this item
    for (let i = 0; i < topicResults.length; i++) {
        // if any topic result matches
        if (filter.length > 0) {
            for (let n = 0; n < filter.length; n++) {

                if (topicResults[i].toLowerCase() === filter[n].id.toLowerCase()) {
                    matchesTopic = true;
                    break;
                }
            }
            if (matchesTopic) {
                break;
            }
        }
    }
    return matchesTopic;
}